import { getIn } from 'formik'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import { useState, useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useAppContext } from '../../../App'
import { uuid } from 'core/helpers/index'

const useStyles = makeStyles(() => ({
  error: {
    border: '5px solid blue'
  },
  charCount: {
    alignSelf: 'flex-end',
    fontSize: '12px',
    color: '#9E9E9E',
    position: 'absolute',
    bottom: '7px'
  },
  underlineError: {
    '&:before': {
      borderBottom: '2px solid #EF3E39 !important'
    }
  }
}))

const TextField = ({
  field,
  form: { touched, errors, setFieldValue },
  noMaxWidth,
  isWidgetForm,
  ...props
}) => {
  const id = useMemo(() => uuid.generator(), [])
  const classes = useStyles()
  const value = field.value || ''
  const maxLength = 100

  const [showError, setShowError] = useState(false)
  const { registerCharLimitError } = useAppContext()

  const handleChange = (e) => {
    const newValue = e.target.value
    setFieldValue(field.name, newValue)

    const error = isWidgetForm && newValue.length > 100
    setShowError(error)
    registerCharLimitError(id, error)
  }

  return (
    <FormControl
      error={!!(getIn(touched, field.name) && getIn(errors, field.name))}
      className={`form-field text-field ${noMaxWidth ? 'noMaxWidth' : ''}`}
      style={{ position: 'relative' }}
    >
      <InputLabel htmlFor={field.name}>{props.label}</InputLabel>

      <Input
        id={field.name}
        value={value}
        {...field}
        {...props}
        onChange={handleChange}
        classes={{
          underline: showError ? classes.underlineError : undefined
        }}
        inputProps={{
          style: { width: isWidgetForm ? '90%' : '100%' }
        }}
      />

      {isWidgetForm && (
        <span className={classes.charCount}>
          {value.length}/{maxLength}
        </span>
      )}

      {showError && (
        <span
          style={{
            color: '#EF3E39',
            position: 'absolute',
            bottom: '-16px',
            fontSize: '12px'
          }}
        >
          O campo deve ter no máximo 100 caracteres.
        </span>
      )}

      {!!(
        field.name &&
        getIn(touched, field.name) &&
        getIn(errors, field.name)
      ) && <FormHelperText>{getIn(errors, field.name)}</FormHelperText>}
    </FormControl>
  )
}

export default TextField
